import { Text } from "@meditect/medibase-components";

export const SalesCannotEditOldSaleError = () => {
  return <Text>Impossible de modifier une vente déjà modifiée</Text>;
};
